import { z } from 'zod'

export const batchDeleteTransfersSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
})

export type BatchDeleteTransfersDto = z.infer<typeof batchDeleteTransfersSchema>
